import {
  Box,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { connectors, ConnectorType } from "@pufflig/prompt-studio-types";
import { TemplateCard } from "@pufflig/prompt-studio-ui";
import { Suspense } from "react";
import { integrationData } from "../../constants";

interface ConnectorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOpenConnectorConfigModal: (connectorType: ConnectorType) => void;
}

export const ConnectorModal = (props: ConnectorModalProps) => {
  const { isOpen, onClose, onOpenConnectorConfigModal } = props;
  return (
    <>
      <Modal closeOnOverlayClick={false} variant="large" size="6xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader padding="spacing-lg">
            <Text textStyle="heading/3">Data connection</Text>
            <ModalCloseButton
              mt="4px"
              border="2px solid"
              borderColor="border.tertiary"
              borderRadius="radius-sm"
              py="1rem"
              px="1.125rem"
            />
          </ModalHeader>
          <ModalBody display="flex">
            <Flex mb="spacing-xxl" direction="column" width="100%" gap="spacing-lg" minHeight="30rem">
              <Flex width="100%" gap="spacing-lg" flexWrap="wrap" overflowY="auto" maxH="30rem">
                <>
                  {Object.values(connectors)
                    .filter((type) => integrationData[type].isAvailable)
                    .map((type) => {
                      const { title, logo } = integrationData[type];
                      return (
                        <TemplateCard
                          key={type}
                          picture={
                            <Suspense fallback={<Spinner />}>
                              <Flex justifyContent="center" alignItems="center" width="100%" py="2rem">
                                <Box height="3.125rem">{logo}</Box>
                              </Flex>
                            </Suspense>
                          }
                          title={title}
                          onClick={() => {
                            onOpenConnectorConfigModal(type);
                            onClose();
                          }}
                          icon="add"
                        />
                      );
                    })}
                </>
              </Flex>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
